<div class="wrapper wrapper-content mtv-parcels-page row">
    <div class="ibox mainPartPage"
         [ngStyle]="{width: incidentReportsService.showDetailedView ? 'calc(100% - 420px)' : ''}">
        <div class="ibox-content">
            <div class="row">
                <div class="col-sm-7">
                    <filter [tabHeading]="'Incident Reports'" [buildings]="incidentReportsService.buildingsForRead"></filter>
                </div>

                <incident-reports-filter (emitReports)="incidentReports = $event"></incident-reports-filter>

                <div *ngIf="incidentReportsService.canEdit()" class="col-sm-3">
                    <button type="button"
                            class="btn btn-w-m btn-primary pull-right"
                            (click)="incidentReportsService.isIncidentReportModalShow = true">
                        <i class="fa fa-plus-circle"></i> New Incident Report
                    </button>
                </div>

            </div>
            <div class="row">
                <div class="col-sm-12">
                    <filters-view [incidentReports]="incidentReports"></filters-view>
                </div>
            </div>
            <tabs-wrapper>
                <tab-item [tabId]="'allIncidentReports'" [ngClass]="{'sk-loading': incidentReportsService.spinnerShow}">
                    <incident-reports-list></incident-reports-list>
                </tab-item>
                <pagination *ngIf="incidentReportsService.data.allIncidentReports.total && urlService.queryParams['page']"
                            [total]="incidentReportsService.data['allIncidentReports'].total">
                </pagination>
                <spinner [spinnerShow]="incidentReportsService.spinnerShow"></spinner>
            </tabs-wrapper>
        </div>

        <div *ngIf="incidentReportsService.showDetailedView"
             class="animated animated-directory slideInRight detailed-view dv-sidebar">
            <incident-report-detailed-view *ngIf="incidentReportsService.showDetailedView"></incident-report-detailed-view>
        </div>
    </div>
</div>

<incident-reports-modal *ngIf="incidentReportsService.isIncidentReportModalShow"></incident-reports-modal>
<send-incident-report-modal *ngIf="incidentReportsService.isSendIncidentReportModalShow"></send-incident-report-modal>
<incident-report-history-modal *ngIf="incidentReportsService.historyModalIncidentReport"></incident-report-history-modal>

<view-attachment-modal *ngIf="incidentReportsService.es.isViewAttachmentModalShow"></view-attachment-modal>



// WEBPACK FOOTER //
// /app/src/app/views/incident-reports/incident-reports.component.html